import { BLOB_CONTENT_ENDPOINT } from "api/endpoints";
import classNames from "classnames"
import { Journal } from "models/journal"
import { PropsWithChildren } from "react"
import { PropsWithClassAndStyle } from "utils/props"

function Field({ name, children }: PropsWithChildren<{ name: string }>) {
  return <p>
    <span className="text-semidark-grey">{name}: </span>
    {children}
  </p>
}

export function JournalCard({ journal, full, focused, onClick, border }: PropsWithClassAndStyle<{ journal: Journal; full?: boolean; focused?: boolean; onClick?: () => void; border?: boolean }>) {
  // journal.indexes_v2 = { elibrary: "https://www.elibrary.ru/title_about_new.asp?id=164360" }

  return <div className={classNames(
    { "border border-light-grey rounded-xl p-1": !!border },
    "flex flex-col gap-1",
    "relative",
    { "bg-light-grey": !!focused },
  )} onClick={onClick}>
    {/* {!!focused && <img className="absolute top-1 right-1" src="/images/circle-checkmark-secondary.svg" width={24} height={24} />} */}
    <div className="flex flex-row gap-1 items-center">
      <img src={journal.thumbnail_blob_id ? BLOB_CONTENT_ENDPOINT(journal.thumbnail_blob_id) : journal.thumbnail_url} className="w-5 h-auto rounded-lg" />
      <div className="flex flex-col gap-0.5">
        <h2 className="text-xl font-bold">{journal.name}</h2>
        <Field name="ISSN (print)">
          {journal.issn}
        </Field>
        <Field name="ISSN (online)">
          {journal.issn_online}
        </Field>
      </div>
    </div>
    {!!full && <>
      <div className="flex flex-row gap-0.5">
        <a className="text-secondary underline" target="_blank" rel="noreferrer" href={journal.url}>Главная страница</a>
        {!!journal.guidelines_url && <>
          <span className="text-grey">•</span>
          <a className="text-secondary underline" target="_blank" rel="noreferrer" href={journal.guidelines_url}>Правила</a>
        </>}
        {journal.contacts_url && <>
          <span className="text-grey">•</span>
          <span><a className="text-secondary underline" target="_blank" rel="noreferrer" href={journal.contacts_url}>Контакты</a></span>
        </>}
      </div>
      <div className="flex flex-row flex-wrap gap-1">
        {journal.indexes_v2?.elibrary && <a href={journal.indexes_v2.elibrary} target="_blank" rel="noreferrer"><img src="https://cdn.elpub.ru/assets/img/banners/elibrary.jpg" className="cursor-pointer h-1 w-auto" /></a>}
        {journal.indexes_v2?.white_list && <a href={journal.indexes_v2.white_list} target="_blank" rel="noreferrer"><img src="https://cdn.elpub.ru/assets/img/banners/belyi_spisok_banner120x33.png" className="cursor-pointer h-1 w-auto" /></a>}
        {journal.indexes_v2?.cyber_leninka && <a href={journal.indexes_v2.cyber_leninka} target="_blank" rel="noreferrer"><img src="https://cdn.elpub.ru/assets/img/banners/cyberleninka120x33.jpg" className="cursor-pointer h-1 w-auto" /></a>}
        {journal.indexes_v2?.sjr && <a href={journal.indexes_v2.sjr} target="_blank" rel="noreferrer"><img src="https://cdn.elpub.ru/assets/img/banners/SJR.gif" className="cursor-pointer h-1 w-auto" /></a>}
        {journal.indexes_v2?.mendeley && <a href={journal.indexes_v2.mendeley} target="_blank" rel="noreferrer"><img src="https://cdn.elpub.ru/assets/img/banners/Mendeley.jpg" className="cursor-pointer h-1 w-auto" /></a>}
        {journal.indexes_v2?.google_scholar && <a href={journal.indexes_v2.google_scholar} target="_blank" rel="noreferrer"><img src="https://cdn.elpub.ru/assets/img/banners/googlescholar.jpg" className="cursor-pointer h-1 w-auto" /></a>}
        {journal.indexes_v2?.cross_ref && <a href={journal.indexes_v2.cross_ref} target="_blank" rel="noreferrer"><img src="https://cdn.elpub.ru/assets/img/banners/crossref1.png" className="cursor-pointer h-1 w-auto" /></a>}
        {journal.indexes_v2?.open_alex && <a href={journal.indexes_v2.open_alex} target="_blank" rel="noreferrer"><img src="https://cdn.elpub.ru/assets/img/banners/openalex_120x33.jpg" className="cursor-pointer h-1 w-auto" /></a>}
      </div>
    </>}
  </div>
}
